<template>
  <div>
    <list
      row-key="ExamId"
      ref="list"
      unit="考试记录管理"
      :expand-all-row="true"
      @reset="$refs.treeSelect.clearHandle();"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="归属机构">
          <tree-select
            ref="treeSelect"
            :props="props"
            :options="TreeData"
            :value="DpId"
            :clearable="true"
            :accordion="true"
            :parentSelect="true"
            placeholder="请选择"
            @node-select="onTreeSelect($event)"
          />
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="params.StudentName" placeholder="请输入姓名" clearable/>
        </el-form-item>
        <el-form-item label="考试类别">
          <select-ks ref="selectKs" v-model.trim="params.ExamCategory" clearable/>
        </el-form-item>
        <el-form-item label="考试结果">
          <el-select   v-model="params.Result" placeholder="请选择考试结果" clearable>
            <el-option label="未考试" :value="0"></el-option>
            <el-option label="通过" :value="1"></el-option>
            <el-option label="不通过" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="培训车型">
          <select-car ref="selectCar2" v-model.trim="params.CarType" clearable/>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="FullName" label="姓名"  />
        <el-table-column prop="CertNo" label="证件号码" width="160"/>
        <el-table-column prop="CarType" label="培训车型"  />
        <el-table-column prop="Subject" label="考试科目"  />
        <el-table-column prop="ExamCategory" label="考试类别"  />
        <el-table-column prop="ApplyTime" label="申请时间" min-width="110">
          <template slot-scope="{row}">
            {{$commonJs.toDateString(row.ApplyTime)}}
          </template>
        </el-table-column>
        <el-table-column prop="ExamDate" label="考试时间" min-width="110">
          <template slot-scope="{row}">
            {{$commonJs.toDateString(row.ExamDate)}}
          </template>
        </el-table-column>
        <el-table-column prop="DpName" label="归属机构" min-width="190" />
        <el-table-column prop="Result" label="考试结果" width="90" align="center" >
            <template slot-scope="{row}">
              <el-tag type="success" v-if="row.Result==1">通过</el-tag>
              <el-tag type="danger" v-else-if="row.Result==2">不通过</el-tag>
              <el-tag type="primary" v-else>未考试</el-tag>
            </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import selectCar from "@/components/cartype/select";
import selectKs from "@/components/basic/kslb/select";
import treeSelect from "@/components/common/treeSelect";

export default {
  mixins: [listMixin],
  components: { 
    list, 
    selectCar,
    selectKs,
    treeSelect
  },
  data() {
    return {
      api: require("@/api/st/exam").default,
      dpApi: require("@/api/basic/dp").default,
      params: {
        StudentName: "",
        ExamCategory: "",
        DpIdChain: "",
        CarType: "",
        Result: null,
      },
      DpId: null,
      TreeData: [],
      props: {
        value: "DpId",
        label: "DpName",
        children: "children",
      },
    };
  },
  beforeMount() {
    this.dpApi.getAuthList({ DpTypes: [2,3], Status: 3, NoReturnParent: true }).then((res) => {
      this.TreeData = this.$commonJs.toTreeData(res.Data, "DpId");
    });
  },
  methods: {
    onExport() {
      this.api.export(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
    },
    onTreeSelect(t) {
      if (!t) {
        this.DpId = null;
        this.params.DpIdChain = "";
      } else {
        this.params.DpIdChain = t.IdChain;
        this.DpId = t.DpId;
      }
    },
    delRange(Ids) {
      this.api.delete({ Ids }).then((res) => {
          if (res.Code == 0) {
            this.$message.success("取消成功");
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
      });
    },
  },
};
</script>